import { useEffect } from 'react';
import { getSettings } from '../lib/api';

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [key, val] = selector.replace('meta[', '').replace(']', '').split('=');
    el.setAttribute(key, val.replace(/["']/g, ''));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

const setLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function SeoHead() {
  useEffect(() => {
    getSettings().then((s) => {
      const seo = s?.seo;
      if (!seo) return;
      if (seo.title) document.title = seo.title;
      setMeta('meta[name="description"]', 'content', seo.description);
      setMeta('meta[name="keywords"]', 'content', seo.keywords);
      setMeta('meta[property="og:title"]', 'content', seo.ogTitle);
      setMeta('meta[property="og:description"]', 'content', seo.ogDescription);
      setMeta('meta[property="og:image"]', 'content', seo.ogImage);
      setMeta('meta[name="twitter:title"]', 'content', seo.ogTitle);
      setMeta('meta[name="twitter:description"]', 'content', seo.ogDescription);
      setMeta('meta[name="twitter:image"]', 'content', seo.ogImage);
      setMeta('meta[name="robots"]', 'content', seo.robotsIndex === false ? 'noindex, nofollow' : 'index, follow');
      if (seo.canonicalUrl) {
        setMeta('meta[property="og:url"]', 'content', seo.canonicalUrl);
        setLink('canonical', seo.canonicalUrl);
      }
    }).catch(() => {});
  }, []);
  return null;
}
